function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgScroll(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 200 200",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlSpace: "preserve",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 1.5
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.839161,0,0,1.21678,-39.648,-29.3706)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M125.5,34C136.369,34 150.249,35.608 159.477,39.955C167.778,43.864 172.824,46.859 179.007,53.495C190.907,66.267 191.439,87.478 191.439,106.294C191.439,125.139 189.694,141.496 177.762,154.274C171.274,161.223 163.417,166.879 154.624,170.81C145.726,174.788 135.869,177 125.5,177C114.957,177 104.944,174.713 95.93,170.609C87.662,166.844 80.234,161.55 74.009,155.088C61.622,142.229 57.972,125.542 57.972,106.294C57.972,87.91 57.379,67.877 68.797,55.204C74.801,48.54 79.656,45.476 87.767,41.441C97.341,36.679 114.089,34 125.5,34Z",
    style: {
      fill: "none",
      stroke: "black",
      strokeWidth: "15.82px"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M171,14L171,144L153,144L171,186L189,144L171,144M65,49L65,78",
    style: {
      fill: "none",
      stroke: "black",
      strokeWidth: "16.53px"
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgScroll);
export default __webpack_public_path__ + "static/media/scroll.dd7573dffaedbf9f85ff1ff2d25bc531.svg";
export { ForwardRef as ReactComponent };